import _ from 'lodash'
import Vue from 'vue'
import createCrudModule from 'vuex-crud'
import api from 'utils/api'

const state = {
  meta: {},
  project: null
}

export default createCrudModule({
  client: api.client,
  resource: 'invoices',
  parseList: res => res.data,
  parseSingle: res => res.data,
  onFetchListSuccess: (state, { meta }) => {
    if (meta) state.meta = meta;
  },
  onFetchSingleSuccess: (state, { data, included }) => {
    state.project = _.find(included, i => i.id === data.relationships.project.data.id && i.type === 'project');
  },
  customUrlFn: (id, params) => `/projects/${params.project_id}/invoices${id ? '/'+id : ''}`,
  state
});